<section>
  <div class="header">
    <h1>Round And Clinics</h1>
  </div>

  <div class="table-container">
  <table>
    <thead>
      <tr>
        <th style="width: 20%;">Round</th>
        <th style="width: 60%;">Note</th>
        <th style="width: 25%;">Doctor</th>
        <th style="width: 20%;">Select</th>
      </tr>
    </thead>

    <tbody>
      <ng-container *ngFor="let roundand of roundandclinic; let i = index">
        <tr *ngIf="i === 0 || roundand.date !== roundandclinic[i - 1].date">
          <td colspan="4" class="date-row" style="background-color: rgb(66, 66, 67);color: white;">{{ roundand.date }}</td>
        </tr>

        <tr>
          <td>{{ roundand.notetype }}</td>
          <td>{{ roundand.note }}</td>
          <td>{{ roundand.extra }}</td>
          <td class="center">
            <button class="btn1" (click)="Selectroundandclinic(roundand)">Select</button>
            <button class="btn2" (click)="MessegeDelete(roundand)">Delete</button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

</section>
